import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=2f6cefb8"
import script from "./EditTeam.vue?vue&type=script&lang=js"
export * from "./EditTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports